import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import axios from "axios";
import {ProgressBar} from "react-bootstrap";

const AICreditsUsage = ({ onUsageFetch }) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [usage, setUsage] = useState({
        available: 0,
        maximum: 0,
        hasOwnCredits: false,
        extraCredits: 0,
    })

    useEffect(() => {
        fetchUsage();
    }, []);

    const fetchUsage = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/ai/credits-usage`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: company.id,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                const fetchedData = {
                    available: res.data.available,
                    maximum: res.data.maximum,
                    hasOwnCredits: res.data.hasOwnCredits,
                    extraCredits: res.data.extraCredits,
                };
                setUsage(fetchedData)
                if (typeof onUsageFetch === 'function') {
                    onUsageFetch(fetchedData);
                }
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    return (
        <React.Fragment>
            {usage.maximum > 0 && (
                <React.Fragment>
                    <div className={"mb-1"}>
                        Διαθέσιμα AI Credits: <strong>({usage.available} / {usage.maximum})</strong>
                        {usage.extraCredits > 0 && (
                            <span
                                className={"ml-1"}
                                style={{
                                    backgroundColor: "#fef3c7",
                                    color: "#b45309",
                                    border: "1px solid #fcd34d",
                                    borderRadius: "12px",
                                    padding: "1px 8px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                }}
                            >
                            + {usage.extraCredits} Extra
                        </span>
                        )}
                    </div>
                    <ProgressBar
                        now={Math.round(usage.available / usage.maximum * 100)}
                        striped
                        style={{ height: "25px" }}
                    />
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default AICreditsUsage;
